import { AFTYPE } from '../types/appsflyer'

export const getOneLinkUrl = (): string | undefined => {
  //Initializing Smart Script arguments
  const oneLinkURL = 'https://gopuff.onelink.me/Iig5/'
  const mediaSource = { defaultValue: 'organic', keys: ['media_source'] }

  //Function is embedded on the window object in a global parameter called window.AF_SMART_SCRIPT.
  //Onelink URL is generated

  const result = (
    global?.window as AFTYPE
  )?.AF_SMART_SCRIPT?.generateOneLinkURL({
    afParameters: {
      afCustom: [
        { gpat: { keys: ['gpat'] } },
        { media_source: { keys: ['utm_source'] } },
        { channel: { keys: ['utm_medium'] } },
        { campaign: { keys: ['utm_campaign'] } },
        { keyword: { keys: ['utm_term'] } },
        { ad: { keys: ['utm_content'] } },
        { af_sub1: { keys: ['campaignid'] } },
        { af_sub2: { keys: ['adgroupid'] } },
        { af_sub3: { keys: ['adid'] } },
        { af_sub4: { keys: ['inmedia'] } },
        { googleClickIdKey: { defaultValue: document.referrer, keys: [] } },
        { mscklid: { keys: ['mscklid'] } },
        { fbcklid: { keys: ['fbclkid'] } },
      ],
      mediaSource: mediaSource,
    },
    oneLinkURL,
  })
  return result?.clickURL
}
